module.exports = __webpack_public_path__ + "images/featured-product-texture.ea78800882.svg";